module.exports = __webpack_public_path__ + "img/BFTV.b0e2af0e.png";